<template>
  <div v-if="data.document_details !== null">
    <section
      v-if="data.document_details.length"
      class="pb-2"
    >
      <h3 class="pb-1">
        Docs Filing Details
      </h3>
      <b-row>
        <b-col class="col-12">
          <app-collapse :type="'border'">
            <app-collapse-item
              title="View Docs Filing Details"
              class="text-info"
            >
              <b-table
                stacked
                responsive="sm"
                :items="data.document_details"
              /> </app-collapse-item></app-collapse>
        </b-col>
      </b-row>
    </section>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BTable,
} from 'bootstrap-vue'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BTable,
    AppCollapse,
    AppCollapseItem,
  },
  props: {
    matter: {
      default: null,
    },
  },
  data() {
    return {
      data: this.matter,
    }
  },
}
</script>
